import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _cloneDeep from "lodash/cloneDeep";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import fetchAPI from 'utils/http/fetchAPI';
import endUserMessages from 'utils/endUserMessages';
import { LOAD_CONFIG, PLOT_DATA_LOADED } from 'redux/actionTypes/componentConfig';
import { initialPlotConfigStates } from 'redux/reducers/componentConfig/initialState';
import handleError from 'utils/http/handleError';
import httpStatusCodes from 'utils/http/httpStatusCodes';
import { mergeObjectReplacingArrays } from 'utils/arrayUtils';

// plotType is null when loading plot data without config
// for example when qc plot updates are received
var loadPlotConfig = function loadPlotConfig(experimentId, plotUuid) {
  var plotType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var signal = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var data, plotConfig, _e$error;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchAPI("/v2/experiments/".concat(experimentId, "/plots/").concat(plotUuid), signal ? {
              signal: signal
            } : {});
          case 3:
            data = _context.sent;
            if (plotType) {
              plotConfig = mergeObjectReplacingArrays(_cloneDeep(initialPlotConfigStates[plotType]), data.config);
              dispatch({
                type: LOAD_CONFIG,
                payload: {
                  experimentId: experimentId,
                  plotUuid: plotUuid,
                  plotType: plotType,
                  plotData: data.plotData,
                  config: plotConfig
                }
              });
            } else {
              dispatch({
                type: PLOT_DATA_LOADED,
                payload: {
                  experimentId: experimentId,
                  plotUuid: plotUuid,
                  plotData: data.plotData
                }
              });
            }
            _context.next = 15;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            if (!(((_e$error = _context.t0.error) === null || _e$error === void 0 ? void 0 : _e$error.name) === 'AbortError' || _context.t0.name === 'AbortError')) {
              _context.next = 11;
              break;
            }
            return _context.abrupt("return");
          case 11:
            if (!(_context.t0.statusCode === httpStatusCodes.NOT_FOUND)) {
              _context.next = 14;
              break;
            }
            dispatch({
              type: LOAD_CONFIG,
              payload: {
                experimentId: experimentId,
                plotUuid: plotUuid,
                plotType: plotType,
                plotData: [],
                config: _cloneDeep(initialPlotConfigStates[plotType])
              }
            });
            return _context.abrupt("return");
          case 14:
            handleError(_context.t0, endUserMessages.ERROR_FETCHING_PLOT_CONFIG);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 7]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default loadPlotConfig;